<div app-sidenav>
  <header>
    <div class="flex items-center justify-between p-5">
      <h1 translate class="text-xl font-normal text-theme-950">trilhas.estudio.trilha.anexos</h1>
    </div>
  </header>
  <hr app-divider class="!-mx-5" />
  <div class="mt-5 h-screen w-full md:h-full">
    <div class="flex w-full flex-col gap-4">
      <ng-container *ngFor="let annex of anexos$ | async">
        <div
          class="flex cursor-pointer items-center justify-between gap-2 rounded-lg bg-[#fcfcfc] p-4 pb-2 shadow-md"
          (click)="onOpenAnnex(annex.file)"
        >
          <div class="h-16 w-16 rounded-full bg-[#f6f4f4] p-4 shadow-inner">
            <svg-icon class="!w-6 rounded-full" [src]="'/assets/images/files/' + annex.extensao + '.svg'"> </svg-icon>
          </div>
          <div class="ml-5 flex flex-col items-start justify-start py-2 lg:ml-0 lg:py-0">
            <p class="w-48 break-words text-base font-semibold lg:w-56">
              {{ annex.nome_arquivo }}
            </p>
            <p class="text-theme-400">{{ annex.extensao }}</p>
          </div>
          <button type="button" app-icon-button class="flex place-items-center justify-center">
            <svg-icon class="w-6 text-theme-500 hover:text-theme-700" src="assets/icons/icon-view.svg"></svg-icon>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
